module.exports = __webpack_public_path__ + "static/media/gold.13c6bf51.svg";